// pages/admin/mypage/AdminMyPage.tsx
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getApiUrl, fetchWithAuth } from '../../../api'

interface MemberMe {
  name: string
  login_id: string
  phone: string
  email: string
}

export default function AdminMyPage() {
  const navigate = useNavigate()
  const [member, setMember] = useState<MemberMe | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchWithAuth(getApiUrl('/marubit/api/member/me'))
      .then(res => (res.ok ? res.json() : null))
      .then((data: MemberMe | null) => { if (data) setMember(data) })
      .catch(e => console.error('회원 정보 로딩 실패:', e))
      .finally(() => setLoading(false))
  }, [])

  const rows = [
    { label: '아이디', value: member?.login_id },
    { label: '이름', value: member?.name },
    { label: '휴대폰번호', value: member?.phone },
    { label: '이메일', value: member?.email },
  ]

  return (
    <div className="bg-[#f5f2f0] min-h-screen p-8">
      <div className="max-w-[680px] mx-auto">

        {/* Header */}
        <div className="mb-6">
          <h1 className="text-[22px] font-extrabold text-[#2a1f1a] mb-1">마이페이지</h1>
          <p className="text-[13px] text-gray-400">내 계정 정보를 확인할 수 있습니다.</p>
        </div>

        <div className="bg-white rounded-2xl border border-[#e8e0dc] px-6 py-6 shadow-[0_2px_12px_rgba(136,114,103,0.06)]">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-[14px] font-bold text-[#5a3d32] m-0">내 정보</h2>
            <button
              onClick={() => navigate('/admin/mypage/edit')}
              className="px-4 py-2 text-[13px] font-semibold text-white bg-[#887267] rounded-lg border-none cursor-pointer hover:bg-[#6b5248] transition-colors"
            >
              수정
            </button>
          </div>

          {loading ? (
            <div className="py-16 text-center text-[14px] text-gray-400">불러오는 중...</div>
          ) : (
            <div className="divide-y divide-[#f5f0ec]">
              {rows.map(row => (
                <div key={row.label} className="flex items-center py-3">
                  <span className="w-[110px] shrink-0 text-[13px] text-gray-400">{row.label}</span>
                  <span className="text-[14px] text-[#2a1f1a] font-medium">{row.value ?? '-'}</span>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  )
}
